// Shared helper for escaping user-supplied strings before splicing them
// into a RegExp. Centralised because the three editor tabs all need to
// match variable keys (which legitimately contain `.`) inside larger
// patterns and were otherwise duplicating the same one-liner.
export const escapeRegExp = (s: string) =>
  s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
